"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Label = function Label(props) {
  var labelCss = (0, _classnames["default"])("label-container", props.colorTheme, props.shapeStyle, props.type, props.className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "label-component",
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: labelCss
  }, props.text ? props.text : ""));
};

Label.propTypes = {
  colorTheme: _propTypes["default"].oneOf(["grey", "teal", "red", "purple", "coal", "grape"]),
  shapeStyle: _propTypes["default"].oneOf(["stroke", "fill"]),
  type: _propTypes["default"].oneOf(["text", "count"]),
  className: _propTypes["default"].string,
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].number]),
  onClick: _propTypes["default"].func
};
Label.defaultProps = {
  colorTheme: "teal",
  shapeStyle: "stroke",
  type: "text",
  className: "",
  text: "Status"
};
var _default = Label;
exports["default"] = _default;